import React from 'react';
import { Settings as SettingsIcon, User, Shield, Bell, Database } from 'lucide-react';

const Settings: React.FC = () => {
    return (
        <div className="space-y-6">
            <div className="flex items-center space-x-3">
                <SettingsIcon className="h-6 w-6 text-gray-600" />
                <h2 className="text-2xl font-bold text-gray-900">Settings</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Profile Settings */}
                <div className="card">
                    <div className="flex items-center space-x-3 mb-4">
                        <User className="h-5 w-5 text-gray-600" />
                        <h3 className="text-lg font-semibold text-gray-900">Profile Settings</h3>
                    </div>
                    <p className="text-gray-600 mb-4">Manage your personal information and preferences.</p>
                    <button className="btn-primary">Edit Profile</button>
                </div>

                {/* Security Settings */}
                <div className="card">
                    <div className="flex items-center space-x-3 mb-4">
                        <Shield className="h-5 w-5 text-gray-600" />
                        <h3 className="text-lg font-semibold text-gray-900">Security</h3>
                    </div>
                    <p className="text-gray-600 mb-4">Manage your password and security settings.</p>
                    <button className="btn-secondary">Change Password</button>
                </div>

                {/* Notifications */}
                <div className="card">
                    <div className="flex items-center space-x-3 mb-4">
                        <Bell className="h-5 w-5 text-gray-600" />
                        <h3 className="text-lg font-semibold text-gray-900">Notifications</h3>
                    </div>
                    <p className="text-gray-600 mb-4">Configure your notification preferences.</p>
                    <button className="btn-secondary">Configure</button>
                </div>

                {/* Data Management */}
                <div className="card">
                    <div className="flex items-center space-x-3 mb-4">
                        <Database className="h-5 w-5 text-gray-600" />
                        <h3 className="text-lg font-semibold text-gray-900">Data Management</h3>
                    </div>
                    <p className="text-gray-600 mb-4">Export data and manage backups.</p>
                    <button className="btn-secondary">Export Data</button>
                </div>
            </div>
        </div>
    );
};

export default Settings;
